import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonDataService } from '../../common-data.service';

@Component({
  selector: 'app-roster-teams-pagination',
  templateUrl: './roster-teams-pagination.component.html',
  styleUrls: ['./roster-teams-pagination.component.scss']
})
export class RosterTeamsPaginationComponent {

  @Input() gridHirView: string = 'grid';
  @Input() filterData: any = '';
  @Input() defaultShowingMembers: number = 5;
  @Input() teams: any[] = [];
  @Input() teamsMeta: any;
  @Input() memViewTeam: any;
  @Input() teamsPerPage: number = 20;
  @Input() teamMemberCurrentPg: number = 1;
  @Input() memberCurrentPg: number = 1;
  @Input() isDemoRoster: boolean = false;

  @Output() teamsPerPageChange = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<number>();

  constructor(public CommonDataService: CommonDataService) {}

  onPerPageChange(): void {
    this.teamsPerPageChange.emit(this.teamsPerPage);
    this.pageChange.emit(1);
  }
}
